import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
	en: {
		translation: {
			home: {
				title: 'I am a Front End developer',
				subTitle:
					'Currently, I love working on a web application with using technologies such as HTML, CSS, React, Tailwimd.',
			},
			about: {
				title: 'About',
				firstP: `Hello, I'm a front-end web developer. I use these technologies like JAVASCRIPT, REACT has also learned HTML and CSS well. Next
                TYPESCRIPT. I am ready to work and study 24/7.`,
				secondP: `
            At the moment I am a 4th year student, faculty of FEKS, front-end
            I have been developing for more than a year, I have experience of working in a team,
            I want to find a job and develop further. I know how to use Google.
            Fast learner. Below you can see examples of my work.`,
			},
			portfolio: {
				title: 'Portfolio',
				subTitle: 'Check out some of my work right here',
				btn: 'View',
			},
			expirience: {
				title: 'Technology',
				subTitle: 'Technologies I have worked with',
			},
			contact: {
				title: 'Contact',
				subTitle: 'Submit the form below to contact me',
			},
			navbar: {
				main: 'home',
				about: 'about',
				portfolio: 'portfolio',
				expirience: 'Technology',
				contact: 'contact',
			},
		},
	},
	ru: {
		translation: {
			home: {
				title: 'Я Front End разработчик',
				subTitle:
					'В настоящее время, я люблю работать над веб-приложением с использованием таких технологий, как HTML, CSS, React, Tailwimd.',
			},
			about: {
				title: 'Обо мне',
				firstP: `Здравствуйте, я Front-End веб-разаработчик. Использую такие технологии
					как JAVASCRIPT, REACT также хорошо изучил HTML и CSS. Следуюжший
					TYPESCRIPT. Я готов работать и учиться 24/7.`,
				secondP: `На данный момент я учусь на 4 курсе, факультет ФЭКС, front-end
					разработкой занимаюсь уже больше года, есть опыт работы в команде,
					хочу найти работу и развиваться дальше. Умею пользоваться Google.
					Быстро учусь. Ниже можна посмотреть примеры моих работ.`,
			},
			portfolio: {
				title: 'Портфолио',
				subTitle: 'Посмотрите некоторые мои работы прямо здесь',
				btn: 'Посмотреть',
			},
			expirience: {
				title: 'Технологии',
				subTitle: 'Технологии с которыми я работал',
			},
			contact: {
				title: 'Контакт',
				subTitle: 'Отправьте форму ниже, чтобы связаться со мной',
			},
			navbar: {
				main: 'Главная',
				about: 'обо мне',
				portfolio: 'портфолио',
				expirience: 'технологии',
				contact: 'контакт',
			},
		},
	},
};

i18n.use(initReactI18next).init({
	resources,
	lng: 'ru',
	fallbackLng: 'ru',

	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
